<form [formGroup]="form" class="row g-3">
  @if (configurationError) {
    <p-message severity="error">{{
      'dataconnection.sorting.invalidConfiguration' | translate
    }}</p-message>
  }
  <div class="col-md-6">
    <label for="sorting-name" class="form-label">{{
      'dataconnection.name' | translate
    }}</label>
    <input
      pInputText
      id="sorting-name"
      formControlName="name"
      class="w-100"
      [invalid]="form.controls.name.invalid && form.controls.name.touched"
    />
    @if (form.controls.name.invalid && form.controls.name.touched) {
      <small class="text-danger" role="alert">{{
        'dataconnection.sorting.nameInvalid' | translate
      }}</small>
    }
  </div>
  @if (!isTemplate) {
    <div class="col-md-6">
      <label for="sorting-identifier" class="form-label">{{
        'dataconnection.identifier' | translate
      }}</label>
      <input
        pInputText
        id="sorting-identifier"
        formControlName="identifier"
        class="w-100"
        [invalid]="
          form.controls.identifier.invalid && form.controls.identifier.touched
        "
      />
      @if (
        form.controls.identifier.invalid && form.controls.identifier.touched
      ) {
        <small class="text-danger" role="alert">{{
          'dataconnection.sorting.identifierInvalid' | translate
        }}</small>
      }
    </div>
  }
  <div class="col-12">
    <label for="sorting-description" class="form-label">{{
      'dataconnection.description' | translate
    }}</label>
    <textarea
      pTextarea
      id="sorting-description"
      formControlName="description"
      rows="2"
      class="w-100"
    ></textarea>
  </div>
  <ng-container formGroupName="configuration">
    <div class="col-md-6">
      <label for="sorting-key" class="form-label">{{
        'dataconnection.sorting.keyField' | translate
      }}</label>
      <input
        pInputText
        id="sorting-key"
        formControlName="keyField"
        placeholder="parcel_Id"
        class="w-100"
        [invalid]="
          form.controls.configuration.controls.keyField.invalid &&
          form.controls.configuration.controls.keyField.touched
        "
      />
      <div class="form-text">
        {{ 'dataconnection.sorting.keyHelp' | translate }}
      </div>
      @if (
        form.controls.configuration.controls.keyField.invalid &&
        form.controls.configuration.controls.keyField.touched
      ) {
        <small class="text-danger" role="alert">{{
          'dataconnection.sorting.keyInvalid' | translate
        }}</small>
      }
    </div>
    <div class="col-md-6">
      <label for="sorting-validity" class="form-label">{{
        'dataconnection.sorting.validityDays' | translate
      }}</label>
      <p-inputnumber
        inputId="sorting-validity"
        formControlName="validityDays"
        [min]="1"
        [max]="365"
        [maxFractionDigits]="0"
        [useGrouping]="false"
        [fluid]="true"
        [invalid]="
          form.controls.configuration.controls.validityDays.invalid &&
          form.controls.configuration.controls.validityDays.touched
        "
      />
      @if (
        form.controls.configuration.controls.validityDays.invalid &&
        form.controls.configuration.controls.validityDays.touched
      ) {
        <small class="text-danger" role="alert">{{
          'dataconnection.sorting.validityInvalid' | translate
        }}</small>
      }
    </div>
    <app-dataconnection-configuration
      [control]="form.controls.configuration.controls.csv"
    >
      @if (
        form.controls.configuration.touched &&
        (form.controls.configuration.controls.csv.invalid ||
          form.controls.configuration.hasError('invalidCsvConfiguration'))
      ) {
        <small class="text-danger" role="alert">{{
          'error.dataconnection.invalid' | translate
        }}</small>
      }
    </app-dataconnection-configuration>
  </ng-container>
  <div class="col-12 form-text">
    {{ 'dataconnection.sorting.retentionHelp' | translate }}
  </div>
</form>
